import request from "@/utils/request";
import { formateObjToParamStr } from "@/utils";
// import { encryptByDES } from '@/utils/crypto'
import qs from "qs";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;
const REAL_BASE_API =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_REAL_BASE_API
    : process.env.VUE_APP_BASE_API;
// 统计
export function getDefaultDate(param) {
  return request({
    url: `${BASE_API}/api/latesttime`,
    method: "get",
    params: param,
  });
}

// 统计
export function getStatisticsData(param) {
  return request({
    url: `${BASE_API}/api/summary`,
    method: "get",
    params: param,
  });
}
//饼图
export function getPieChartData(param) {
  return request({
    url: `${BASE_API}/api/summary`,
    method: "get",
    params: param,
  });
}
export function getPieChartDatapost(data) {
  return request({
    url: `${BASE_API}/api/summary`,
    method: "post",
    data: data,
  });
}
//获取饼图下载地址
export function getPieChartDataUrl(param) {
  return `${REAL_BASE_API}/api/summary?` + formateObjToParamStr(param);
}
//声量图
export function getVolumeTable(param) {
  return request({
    url: `${BASE_API}/api/posts_analyse`,
    method: "get",
    params: param,
  });
}
// 驱动因素声量图
export function getDrivingFactors(param) {
  return request({
    url: `${BASE_API}/api/driving_factors`,
    method: "get",
    params: param,
  });
}
export function getVolumeTablepost(data) {
  return request({
    url: `${BASE_API}/api/posts_analyse`,
    method: "post",
    data: data,
  });
}
//基本信息(驱动因素)页面获取声量图下载地址
export function getDrivingFactorsVolumeTableUrl(param) {
  return `${REAL_BASE_API}/api/driving_factors?` + formateObjToParamStr(param);
}
//获取声量图下载地址
export function getVolumeTableUrl(param) {
  return `${REAL_BASE_API}/api/posts_analyse?` + formateObjToParamStr(param);
}
//社交聆听平台分布、情感分析、声量&互动量、声量&环比、互动量&环比、各平台趋势-声量 、各平台趋势-互动量查询合并接口
export function getSynthesizeData(param) {
  return request({
    url: `${BASE_API}/api/synthesize`,
    method: "get",
    params: param,
  });
}
//合并后的下载地址
export function getSynthesizeDataUrl(param) {
  return `${REAL_BASE_API}/api/synthesize?` + formateObjToParamStr(param);
}
//小红书原文链接跳转地址
export function getXhsPostUrl(param) {
  return request({
    url: `${BASE_API}/api/get_post_url`,
    method: "get",
    params: param,
  });
}
//趋势图
export function getMixChartData(param) {
  return request({
    url: `${BASE_API}/api/trend`,
    method: "get",
    params: param,
  });
}
//获取趋势图下载地址
export function getMixChartDataUrl(param) {
  return `${REAL_BASE_API}/api/trend?` + formateObjToParamStr(param);
}
export function getMixChartDatapost(data) {
  return request({
    url: `${BASE_API}/api/trend`,
    method: "post",
    data: data,
  });
}
//词云图
export function getWords(param) {
  return request({
    url: `${BASE_API}/api/cloud`,
    method: "get",
    params: param,
  });
}
export function getWordspost(data) {
  return request({
    url: `${BASE_API}/api/cloud`,
    method: "post",
    data: data,
  });
}
export function getCloudWords(param) {
  return request({
    url: `${BASE_API}/api/cloud_edit`,
    method: "get",
    params: param,
  });
}
export function getCloudWordsPost(data) {
  return request({
    url: `${BASE_API}/api/cloud_edit`,
    method: "post",
    data: data,
  });
}
//获取词云图下载地址
export function getWordCloudDataUrl(param) {
  return `${REAL_BASE_API}/api/cloud?` + formateObjToParamStr(param);
}
// 帖子列表
export function getpostsList(param) {
  return request({
    url: `${BASE_API}/api/posts/list`,
    method: "get",
    params: param,
  });
}
export function getpostsListpost(data) {
  return request({
    url: `${BASE_API}/api/posts/list`,
    method: "post",
    data: data,
  });
}
//获取帖子列表的下载地址
export function getpostsListDataUrl(param) {
  return `${REAL_BASE_API}/api/posts/list?` + formateObjToParamStr(param);
}
//达人榜
export function getTalentData(param) {
  return request({
    url: `${BASE_API}/api/kols/list`,
    method: "get",
    params: param,
  });
}
//获取达人榜列表的下载地址
export function getTalentDataUrl(param) {
  return `${REAL_BASE_API}/api/kols/list?` + formateObjToParamStr(param);
}
export function getTalentDatapost(data) {
  return request({
    url: `${BASE_API}/api/kols/list`,
    method: "post",
    data: data,
  });
}
//品牌排行榜
export function getBrandData(param) {
  return request({
    url: `${BASE_API}/api/brands/list`,
    method: "get",
    params: param,
  });
}
//获取品牌榜列表的下载地址
export function getBrandDataUrl(param) {
  return `${REAL_BASE_API}/api/brands/list?` + formateObjToParamStr(param);
}
export function getBrandDatapost(data) {
  return request({
    url: `${BASE_API}/api/brands/list`,
    method: "post",
    data: data,
  });
}
//获取话题列表的下载地址
export function getTopicDataUrl(param) {
  return `${REAL_BASE_API}/api/topic/list?` + formateObjToParamStr(param);
}
export function getTopicDatapost(data) {
  return request({
    url: `${BASE_API}/api/topic/list`,
    method: "post",
    data: data,
  });
}
//保存方案
export function saveProj(param) {
  return request({
    url: `${BASE_API}/api/plan`,
    method: "get",
    params: param,
  });
}

//根据id查询名称
export function getNameById(param) {
  return request({
    url: `${BASE_API}/api/idname`,
    method: "get",
    params: param,
  });
}

export function mergeWords(data) {
  return request({
    url: `${BASE_API}/api/web_patch`,
    method: "PUT",
    data: data,
  });
}
export function getMergeWords(param) {
  console.log(param);
  return request({
    url: `${BASE_API}/api/web_patch`,
    method: "get",
    params: param,
  });
}
export function deleteMergeWordsOperate(data) {
  return request({
    url: `${BASE_API}/api/web_patch`,
    method: "DELETE",
    data,
  });
}
//趋势对比
export function getTrendComparison(param) {
  return request({
    url: `${BASE_API}/api/trend/comparison`,
    method: "get",
    params: param,
  });
}
export function getTrendComparisonUrl(param) {
  return `${REAL_BASE_API}/api/trend/comparison?` + formateObjToParamStr(param);
}
//情感占比
export function getAspectPerChart(param) {
  return request({
    url: `${BASE_API}/api/aspect_per`,
    method: "get",
    params: param,
  });
}
//获取情感占比下载地址
export function getAspectPerDataUrl(param) {
  return `${REAL_BASE_API}/api/aspect_per?` + formateObjToParamStr(param);
}
//分平台粉丝占比
export function getFollowerPerChart(param) {
  return request({
    url: `${BASE_API}/api/follower_per`,
    method: "get",
    params: param,
  });
}
//获取分平台粉丝占比下载地址
export function getFollowerPerDataUrl(param) {
  return `${REAL_BASE_API}/api/follower_per?` + formateObjToParamStr(param);
}
//获取交叉分析热力图数据
export function getCrossAnalysisChart(data) {
  return request({
    url: `${BASE_API}/api/cross_analysis`,
    method: "post",
    data: data,
  });
}
export function addBrand(data) {
  return request({
    url: `${BASE_API}/api/web_patch`,
    method: "PUT",
    data: data,
  });
}
export function mergeBrand(data) {
  return request({
    url: `${BASE_API}/api/web_patch`,
    method: "PUT",
    data: data,
  });
}
export function setAddMerageHideBrand(data) {
  return request({
    url: `${BASE_API}/api/web_patch`,
    method: "PUT",
    data: data,
  });
}
export function getAddMerageHideBrand(param) {
  return request({
    url: `${BASE_API}/api/web_patch`,
    method: "get",
    params: param,
  });
}
export function cancelAddMerageHideBrand(data) {
  return request({
    url: `${BASE_API}/api/web_patch`,
    method: "DELETE",
    data,
  });
}
export function getCustomAnalyseTitle(param) {
  return request({
    url: `${BASE_API}/api/custom_analyse_title`,
    method: "get",
    params: param,
  });
}
export function postCustomAnalyseTitle(param) {
  return request({
    url: `${BASE_API}/api/custom_analyse_title`,
    method: "post",
    data: param,
  });
}
